import { Box, Breadcrumbs, Button, Grid, styled, Table, TableBody, TableContainer, TableHead, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react'
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useDispatch } from 'react-redux';
import usePageLoader from '../../Redux/hooks/usePageLoader';
import useSnackBar from '../../Redux/hooks/useSnackBar';
import { categoryNameOptions, useCommonStyles } from '../../utils';
import StyledTableRow from '../Common/StyledTableRow';
import StyledTableCell from '../Common/StyledTableCell';
import NoDataFound from '../Common/NoDataFound';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ErrorHandler from '../../lib/errorHandler';
import CommonTextField from '../Common/CommonTextField';
import CommonDatePicker from '../Common/CommonDatePicker';
import CommonAutoComplete from '../Common/CommonAutoComplete';
import dayjs from 'dayjs';
import { addProcessItem, getItemsByCategory, getLotNumbersByCategory, updateProcessItem } from '../../Redux/Actions/Processing';
import ErrorMessage from '../Common/ErrorMessage';
import { isCompleteDate } from '../../lib/standardDateFormat';
import { getProducts } from "../../Redux/Actions/Inventory";
import Product from '../../Pages/Inventory/Common/Product';


export const machineNameOptions = [
    { id: 1, name: "C1" },
    { id: 2, name: "C2" },
    { id: 3, name: "C3" },
    { id: 4, name: "C4" },
    { id: 5, name: "C5" },
    { id: 6, name: "C6" },
];

export const jobWorkOptions = [
    { id: 1, name: "Job work" },
    { id: 2, name: "Regular" },
];
const categoryOptionForProcessing = [
    { id: 1, name: "Base Paper" },
    { id: 2, name: "Film" },
    { id: 3, name: "Chemical" },
    { id: 4, name: "Ink" },
];

const AddProcessingUnit = ({ setProductName, productName, setSelectedItem, selectedItem, setIsOpenAddProcessingUnit, setData, data, _getProcessItems, purchaseOrderListData, setPurchaseOrderListData, setSearchValue }) => {
    // ============== Hooks ==============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();

    // ============== States ==============
    const [errors, setErrors] = useState({});

    const [lotNumberPage, setLotNumberPage] = useState(1);
    const [lotNumberTotalCount, setLotNumberTotalCount] = useState();
    const [lotNumberList, setLotNumberList] = useState([]);
    const [lotNumberOptions, setLotNumberOptions] = useState([]);
    const [searchLotNumber, setSearchLotNumber] = useState();

    const [allItemsPage, setAllItemsPage] = useState(1);
    const [allItemsTotalCount, setAllItemsTotalCount] = useState();
    const [allItemsList, setAllItemsList] = useState([]);
    const [allItemsOptions, setAllItemsOptions] = useState([]);
    const [searchAllItems, setSearchAllItems] = useState();
    const [products, setProducts] = useState([]);


    // ============== Handler ==============
    const tabelHeader = ["Item(s)", "available Quantity", "Quantity", "Lot Number"]
// console.log(data);
    const breadcrumbs = [
        <Typography color={theme.palette.bgBlack.main} sx={{ opacity: "70%", cursor: "pointer" }} fontFamily={'Satoshi-Medium'} onClick={() => { setIsOpenAddProcessingUnit(false); setData({}); setPurchaseOrderListData([]); setSelectedItem({}); setSearchValue('') }}>
            Processing unit List
        </Typography>,
        <Typography color={theme.palette.bgBlack.main} fontFamily={'Satoshi-Medium'}>
            {selectedItem?._id ? "Edit Processing Unit" : `Add Processing Unit`}
        </Typography>,
    ];

    const handleChange = (name, value) => {
        setData({ ...data, [name]: value })
    }
    const createItemList = () => {
        if (data?.allItems) {
            const newItem = {
                itemName: data.allItems?.item,
                quantity: '',
                availableQuantity: data.allItems?.quantity,
                lotNumber: data?.lotNumber?.lotNumber,
            };
            const isItemExists = purchaseOrderListData?.some((order) => order?.itemName === newItem?.itemName);
            if (isItemExists) {
                setSnackBar("error", "Item already exists.");
            } else {
                setPurchaseOrderListData(prevData => [...prevData, newItem]);
                setData({ ...data, allItems: "" })
            }
        } else {
            setSnackBar("error", "Please select an item.");
        }
    };



    const handleChangeForItems = (index, value, name) => {
        const updatedData = purchaseOrderListData?.map((ele, i) =>
            i === index ? { ...ele, [name]: value } : ele
        );
        const totalQuantity = updatedData.reduce((acc, row) => acc + (Number(row?.quantity) || 0), 0);
        setPurchaseOrderListData(updatedData);
        setData({ ...data, totalQuantity });
    };
    // ============== Validation ==============
    const validation = () => {
        let formIsValid = true;
        let errors = {};
        if (data?.totalOutput < 0) {
            formIsValid = false
            setSnackBar("error", "Total output cannot be negative");
        }
        if (!data?.category?.name) {
            formIsValid = false
            errors.category = "Please select category."
        }
        if (!data?.lotNumber?.lotNumber) {
            formIsValid = false
            errors.lotNumber = "Please select lot number."
        }
        if (purchaseOrderListData?.length === 0) {
            formIsValid = false
            setSnackBar('error', 'Please select item.')
        }
        if (purchaseOrderListData?.some((ele) => ele?.quantity <= 0)) {
            formIsValid = false
            setSnackBar('error', 'Please enter quantity')
        }
        if (!data?.machineName?.name) {
            formIsValid = false
            errors.lotNumber = "Please select machine name."
        }
        if (!data?.jobWork?.name) {
            formIsValid = false
            errors.jobWork = "Please select job work."
        }
        if (!data?.processingDate) {
            formIsValid = false
            errors.processingDate = "Please select processing date."
        }
        if (!data?.processingDate) {
            if (!isCompleteDate(data?.processingDate)) {
                formIsValid = false;
                setSnackBar("error", "Please select valid processing date")
            }
        }
        if(!data?.Product ){
            formIsValid=false
            errors.Product = "please select Product name."
        }
        if(!data?.productQuantity){
            formIsValid = false
            errors.productQuantity = "Please enter product quantity."
        }
        setErrors(errors)
        return formIsValid
    }

    // console.log(data, "data")
    // ============= add Inventory Field API =============
    const _addUpdatePurchseEntry = async () => {
        if (validation()) {
            console.log(data?.productQuantity)
            setFullPageLoader(true);
            let response;
            const purchaseOrderbody = purchaseOrderListData?.map((ele) => {
                return {
                    availableQuantity: ele?.availableQuantity,
                    itemName: ele?.itemName,
                    lotNumber: ele?.lotNumber,
                    quantity: +ele?.quantity
                }
            })
            let body = {
                "processing_date": data?.processingDate ? dayjs(data.processingDate).format("YYYY-MM-DD") : null,
                "machineName": data?.machineName?.name,
                "processing_type": data?.jobWork?.name,
                "lotNumber": data?.lotNumber?.lotNumber,
                "categoryName": data?.category?.name,
                "purchaseOrder": purchaseOrderbody,
                "totalQuantity": data?.totalQuantity,
                "output": data?.totalQuantity,
                "firstWastage": +data?.wastage1,
                "secondWastage": +data?.wastage2,
                "thirdWastage": +data?.wastage3,
                "finalOutput": data?.totalOutput || data?.totalQuantity,
                "description": data?.remarks,
                "productId": data?.ProductId,
                "productQuantity": data?.productQuantity,
            }
            if (selectedItem?._id) {
                body._id = selectedItem?._id
            }
            const fn = selectedItem?._id ? updateProcessItem : addProcessItem
        
            response = await dispatch(fn(body));
            let error = await ErrorHandler(response, setSnackBar);
            if (error) {
                if (response?.payload?.data) {
                    setSnackBar("success", response?.payload?.message)
                    setIsOpenAddProcessingUnit(false)
                    setData({})
                    setPurchaseOrderListData([])
                    _getProcessItems()
                    setSelectedItem({})
                    setSearchValue("")
                    setProductName()
                }
                setFullPageLoader(false);
            }
            setFullPageLoader(false);
        };
    }


    const getProductsData = async () => {
        const body = {}
        const data = await dispatch(getProducts(body));
        setProducts(data?.payload?.data?.data)
    }


    useEffect(() => {
        getProductsData()
    }, [])

    // ============== Get Lot Number API ==============
    const _getLotNumber = async (p, searchText) => {
        let response;
        let body = {
            "category": data?.category?.name,
            "limit": 10,
            "page": p ? p : lotNumberPage,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getLotNumbersByCategory(body));
        { (lotNumberList?.length !== lotNumberTotalCount) && setLotNumberPage(lotNumberPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchLotNumber(searchText ? searchText : "");
            setLotNumberTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setLotNumberList([...lotNumberList, ...response?.payload?.data?.response]);
            }
            if (response?.payload?.data?.count != lotNumberList?.length) {
                if (response?.payload?.data?.response?.length !== 0) {
                    setLotNumberList([...lotNumberList, ...response?.payload?.data?.response]);
                } else {
                    setLotNumberList([])
                }
            }
        }
    };

    const handleChangeInputForLotNumber = async (p, searchText) => {
        let response;
        let body = {
            "category": data?.category?.name,
            "limit": 10,
            "page": p,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getLotNumbersByCategory(body));
        setLotNumberPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchLotNumber(searchText);
            setLotNumberList(response?.payload?.data?.response);
        }
    };

    //------------------  Group API ------------------
    const _getAllItems = async (p, searchText) => {
        let response;
        let body;
        body = {
            "category": data?.category?.name,
            "lotNumber": data?.lotNumber?.lotNumber,
            "limit": 10,
            "page": p ? p : allItemsPage
        }
        response = await dispatch(getItemsByCategory(body));
        { (allItemsList?.length !== allItemsTotalCount) && setAllItemsPage(allItemsPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchAllItems(searchText ? searchText : "");
            setAllItemsTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data?.count != allItemsList?.length) {
                if (response?.payload?.data?.response?.length !== 0) {
                    setAllItemsList([...allItemsList, ...response?.payload?.data?.response]);
                } else {
                    setAllItemsList([])
                }
            }
        }
    };

    const handleChangeInputForAllItems = async (p, searchText) => {
        let response;
        let body;
        body = {
            "category": data?.category?.name,
            "lotNumber": data?.lotNumber,
            "limit": 10,
            "page": p
        }
        response = await dispatch(getItemsByCategory(body));
        setAllItemsPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchAllItems(searchText);
            setAllItemsList(response?.payload?.data?.response);
        }
    };

    // =================== Use Effect ===================
    useEffect(() => {
        if (data?.wastage1 !== undefined || data?.wastage2 !== undefined || data?.wastage3 !== undefined) {
            const totalOutputCount = (+data?.totalQuantity || 0) - ((+data?.wastage1 || 0) + (+data?.wastage2 || 0) + (+data?.wastage3 || 0));
            setData((prevData) => ({
                ...prevData,
                totalOutput: totalOutputCount
            }));
        }
    }, [data?.wastage1, data?.wastage2, data?.wastage3, data?.totalQuantity]);

    useEffect(() => {
        if (data?.category && data?.lotNumber) {
            _getAllItems(1);
        }
    }, [data?.category, data?.lotNumber]);
    useEffect(() => {
        if (data?.category) {
            _getLotNumber(1);
        }
    }, [data?.category]);

    useEffect(() => {
        setLotNumberOptions(lotNumberList?.map((e) => e));
    }, [lotNumberList]);

    useEffect(() => {
        setAllItemsOptions(allItemsList?.map((e) => e));
    }, [allItemsList]);

    return (
        <Grid container padding={"25px"} spacing={2} height={"fit-content"}>
            <Grid item xs={12}>
                <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}> {selectedItem?._id ? "Edit Processing Unit" : `Add Processing Unit`}</Typography>
                <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                >
                    {breadcrumbs}
                </Breadcrumbs>
            </Grid>
            <Grid item xs={12}>
                <Box sx={{ bgcolor: theme.palette.bgWhite.main, borderRadius: "26px", padding: "25px" }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography fontFamily={"Satoshi-Bold"} fontSize={"20px"}>Processing Unit Form</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonDatePicker
                                label="Processing Date"
                                valid
                                onChange={(value) => handleChange("processingDate", value)}
                                value={data?.processingDate || null}
                                name="processingDate"
                            />
                            <ErrorMessage text={!data?.processingDate ? errors.processingDate : ""} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonAutoComplete
                                label="Machine Name"
                                valid
                                placeholder="Select machineName"
                                options={machineNameOptions || []}
                                getOptionLabel={(option) => option?.name || ""}
                                value={data?.machineName || null}
                                onChange={(e, newValue) => handleChange("machineName", newValue)}
                            />
                            <ErrorMessage text={!data?.machineName?.name ? errors.machineName : ""} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonAutoComplete
                                valid
                                label="Job Work"
                                placeholder="Select Job Work"
                                options={jobWorkOptions || []}
                                getOptionLabel={(option) => option?.name || ""}
                                value={data?.jobWork || null}
                                onChange={(e, newValue) => handleChange("jobWork", newValue)}
                            />
                            <ErrorMessage text={!data?.jobWork?.name ? errors.jobWork : ""} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonAutoComplete
                                valid
                                label="Category"
                                placeholder="Select Category"
                                options={categoryOptionForProcessing || []}
                                getOptionLabel={(option) => option?.name || ""}
                                value={data?.category || null}
                                onChange={(e, newValue) => { setData({ ...data, category: newValue, lotNumber: "", allItems: "", totalQuantity: 0 }); setLotNumberOptions([]); setLotNumberList([]); setAllItemsList([]) }}
                            />
                            <ErrorMessage text={!data?.category?.name ? errors.category : ""} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonAutoComplete
                                valid
                                label="Lot Number"
                                placeholder="Select Lot Number"
                                options={lotNumberOptions || []}
                                getOptionLabel={(option) => option?.lotNumber || ""}
                                value={data?.lotNumber || null}
                                onChange={(e, newValue) => { setData({ ...data, lotNumber: newValue, allItems: "", totalQuantity: 0 }); setAllItemsList([]) }}
                                loadData={(lotNumberOptions?.length !== lotNumberTotalCount) ? _getLotNumber : undefined}
                                handleSearch={(e) => handleChangeInputForLotNumber(1, e?.target?.value)}
                                searchValue={searchLotNumber}
                            />
                            <ErrorMessage text={!data?.lotNumber?.lotNumber ? errors.lotNumber : ""} />
                        </Grid>
                        <Grid item xs={6} sm={8} md={9} lg={6} >
                            <CommonAutoComplete
                                valid
                                label="All Items"
                                placeholder="Select Item"
                                options={allItemsOptions || []}
                                getOptionLabel={(option) => option?.item || ""}
                                value={data?.allItems || null}
                                onChange={(e, newValue) => handleChange("allItems", newValue)}
                                loadData={(allItemsOptions?.length !== allItemsTotalCount) ? _getAllItems : undefined}
                                handleSearch={(e) => handleChangeInputForAllItems(1, e?.target?.value)}
                                searchValue={searchAllItems}
                            />
                        </Grid>
                        <Grid item xs={6} sm={4} md={3} lg={3} alignSelf={"end"} >
                            <Button variant='outlined' onClick={() => createItemList()} sx={{ borderRadius: "10px", backgroundColor: "#FFF", padding: "7px 1rem", "&:hover": { backgroundColor: "#FFF" }, }} startIcon={<AddCircleIcon />}>Add items</Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                                <TableContainer>
                                    <Table >
                                        <TableHead>
                                            <StyledTableRow isHeader isBordered style={{ backgroundColor: "#E9E9E9" }}>
                                                {tabelHeader?.map((ele) => {
                                                    return (
                                                        <StyledTableCell align='center'>{ele}</StyledTableCell>
                                                    )
                                                })}
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {purchaseOrderListData?.length > 0 ?
                                                <>
                                                    {purchaseOrderListData?.map((row, index) => {
                                                        return (
                                                            <React.Fragment key={index}>
                                                                <StyledTableRow noColor isBordered>
                                                                    <StyledTableCell isBordered >
                                                                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                            <Box backgroundColor="#F7FAFC" sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "6px 10px", width: "fit-content", minWidth: "50px", textAlign: "center" }}>
                                                                                <Typography fontFamily={"Satoshi-Medium"} fontSize={'12px'}>{row?.itemName ? row?.itemName : "NA"}</Typography>
                                                                            </Box>
                                                                        </Box>
                                                                    </StyledTableCell>
                                                                    <StyledTableCell isBordered >
                                                                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                            <Box backgroundColor="#F7FAFC" sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "6px 10px", width: "fit-content", minWidth: "50px", textAlign: "center" }}>
                                                                                <Typography fontFamily={"Satoshi-Medium"} fontSize={'12px'}>{row?.availableQuantity ? row?.availableQuantity : "NA"}</Typography>
                                                                            </Box>
                                                                        </Box>
                                                                    </StyledTableCell>
                                                                    <StyledTableCell isBordered align='center'>
                                                                        <CommonTextField
                                                                            width={"80px"}
                                                                            type="number"
                                                                            name="quantity"
                                                                            value={row?.quantity}
                                                                            placeholder="Ex. 10"
                                                                            sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                            onChange={(e) => {
                                                                                if (+e?.target?.value <= row?.availableQuantity) {
                                                                                    handleChangeForItems(index, e.target.value, "quantity")
                                                                                } else {
                                                                                    return;
                                                                                }
                                                                            }}
                                                                        />
                                                                    </StyledTableCell>
                                                                    <StyledTableCell isBordered >
                                                                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                            <Box backgroundColor="#F7FAFC" sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "6px 10px", width: "fit-content", minWidth: "50px", textAlign: "center" }}>
                                                                                <Typography fontFamily={"Satoshi-Medium"} fontSize={'12px'}>{row?.lotNumber ? row.lotNumber : "NA"}</Typography>
                                                                            </Box>
                                                                        </Box>
                                                                    </StyledTableCell>
                                                                </StyledTableRow>
                                                            </React.Fragment>
                                                        )
                                                    })}
                                                    <StyledTableRow isBordered sx={{ backgroundColor: "transparent !important", borderTop: "1px solid #13131333" }}>
                                                        <StyledTableCell isBordered></StyledTableCell>
                                                        <StyledTableCell isBordered></StyledTableCell>
                                                        <StyledTableCell isBordered sx={{ display: "flex", justifyContent: "center" }}>
                                                            <Box sx={{ bgcolor: theme.palette.primary.main, color: theme.palette.lightPrimary.main, textAlign: "center", width: "fit-content", minWidth: "80px", padding: "11px 10px", borderRadius: "10px" }}>
                                                                <Typography fontSize={"12px"} fontFamily={"Satoshi-Bold"}>
                                                                    {data?.totalQuantity || 0}
                                                                </Typography>
                                                            </Box>
                                                        </StyledTableCell>
                                                        <StyledTableCell isBordered></StyledTableCell>
                                                    </StyledTableRow>
                                                </>
                                                :
                                                <StyledTableRow>
                                                    <StyledTableCell colSpan={12}>
                                                        <NoDataFound />
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonTextField
                                type="text"
                                label="Output"
                                name="output"
                                disabled
                                value={data.totalQuantity || 0}
                                placeholder="Enter The Output"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonTextField
                                type="number"
                                label="Wastage 1"
                                name="wastage1"
                                value={data.wastage1}
                                placeholder="Enter The Wastage 1"
                                onChange={(e) => {
                                    if (+e?.target?.value >= 0) {
                                        handleChange("wastage1", e.target.value)
                                    } else {
                                        return;
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonTextField
                                type="number"
                                label="Wastage 2"
                                name="wastage2"
                                value={data.wastage2}
                                placeholder="Enter The Wastage 2"
                                onChange={(e) => {
                                    if (+e?.target?.value >= 0) {
                                        handleChange("wastage2", e.target.value)
                                    } else {
                                        return;
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonTextField
                                type="number"
                                label="Wastage 3"
                                name="wastage3"
                                value={data.wastage3}
                                placeholder="Enter The Wastage 3"
                                onChange={(e) => {
                                    if (+e?.target?.value >= 0) {
                                        handleChange("wastage3", e.target.value)
                                    } else {
                                        return;
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonTextField
                                type="number"
                                label="total Output"
                                name="totalOutput"
                                value={data?.totalOutput}
                                disabled
                                placeholder="Enter The total Output"
                            />
                        </Grid>
                        {products.find(p => p._id == productName) ? (
                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <CommonTextField
                                    type="text"
                                    label="Product name"
                                    name="productname"
                                    value={products.find(p => p._id == productName)?.name || ""}
                                    disabled
                                />
                            </Grid>
                        ) : (
                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <CommonAutoComplete
                                    valid
                                    label="Product name"
                                    placeholder="Select product"
                                    options={products || []}
                                    getOptionLabel={(option) => option?.name || ""}
                                    value={data?.Product}
                                    disabled={productName}
                                    onChange={(e, newValue) => {
                                        setData({
                                            ...data,
                                            Product: newValue,
                                            ProductId: newValue?._id || "",
                                            ProductNmae: newValue?.name || "",
                                        });
                                    }}
                                />
                                <ErrorMessage text={errors.Product || ""} />
                            </Grid>
                        )}
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonTextField
                                valid
                                type="number"
                                label="Product Quantity"
                                name="productQuantity"
                                value={data?.productQuantity || null}
                                placeholder="Enter The Product Quantity"
                                onChange={(e) => {
                                    if (+e?.target?.value >= 0) {
                                        handleChange("productQuantity", e.target.value)
                                    } else {
                                        return;
                                    }
                                }}
                            />
                             <ErrorMessage text={errors?.productQuantity || ""} />
                        </Grid>

                        <Grid item xs={12} >
                            <CommonTextField
                                type="text"
                                multiline
                                rows={4}
                                label="Remarks"
                                name="remarks"
                                value={data.remarks}
                                placeholder="Add Any Additional Comments/Remarks....."
                                onChange={(e) => handleChange("remarks", e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} mt={1} display={"flex"} gap={2}>
                            <Button className={classes.cancelButton} onClick={() => { setIsOpenAddProcessingUnit(false); setData({}); setPurchaseOrderListData([]); setSelectedItem({}); setProductName() }}>Cancel</Button>
                            <Button className={classes.saveButton} onClick={() => _addUpdatePurchseEntry()}>Save </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Grid >
        </Grid >
    )
}

export default AddProcessingUnit